<div class="container" style="width: 20%;">
    <H1>Add Provider</H1>

    <div>
        <div class="form-group">
            <label>Provider Name:</label>
            <input class="form-control" name="ProviderName" type="text" [(ngModel)]="ProviderName" required
                placeholder="Enter Provider Name" maxlength="20" />
        </div>


        <div class="form-group">
            <label>Direct Box Size:</label>
            <input class="form-control" name="DirectBoxSize" type="number" min=1 max=300 [(ngModel)]="DirectBoxSize" required
                placeholder="Enter Direct Box Size"
                oninput="this.value =!!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null" />
        </div>

        <div class="form-group">
            <label>Direct Batch Size:</label>
            <input class="form-control" name="DirectBatchSize" type="number" min=1 max=150 [(ngModel)]="DirectBatchSize" required
                placeholder="Enter Direct Batch Size"
                oninput="this.value =!!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null" />
        </div>

        <div class="form-group">
            <label>Indirect Box Size:</label>
            <input class="form-control" name="InDirectBoxSize" type="number" min=1 max=300 [(ngModel)]="InDirectBoxSize" required
                placeholder="Enter Indirect Box Size"
                oninput="this.value =!!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null" />
        </div>

        <div class="form-group">
            <label>Indirect Batch Size:</label>
            <input class="form-control" name="InDirectBatchSize" type="number" min=1 max=150 [(ngModel)]="InDirectBatchSize" required
                placeholder="Enter Indirect Batch Size"
                oninput="this.value =!!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null" />
        </div>


        <div class="form-group" style="display: inline-flex;">

            <div style="float: left;margin-right: 20px;">
                <button class="btn btn-primary btn-lg btn-block" type="submit" (click)="Back()">Back</button>
            </div>


            <div style="float: left;margin-right: 20px;margin-left:20px;">
                <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
            </div>

            <div style="float: right;margin-left:20px;">
                <button class="btn btn-success btn-lg btn-block" type="submit"
                    [disabled]="!ProviderName || !DirectBoxSize ||!DirectBatchSize|| !InDirectBoxSize ||!InDirectBatchSize" (click)="Save()">Save</button>
            </div>
        </div>




    </div>

</div>


<div style="float: right;margin-left:20px;">
    <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
    </button>
</div>
<ng-template #content let-modal ID="Errormessage">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            {{PopupTitle}}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

            <span aria-hidden="true">
                ×
            </span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="dateOfBirth">
                    {{DisplayErrormessage}}
                </label>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
            Done
        </button>
    </div>
</ng-template>